import React from 'react';

const CancelOrderModal = ({ onConfirm, onCancel }) => {
    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '20px'
        }}>
            <div style={{
                background: 'white',
                borderRadius: '16px',
                padding: '40px',
                maxWidth: '500px',
                width: '100%',
                boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                textAlign: 'center'
            }}>
                <div style={{ fontSize: '48px', marginBottom: '20px' }}>
                    ⚠️
                </div>
                
                <h2 style={{ 
                    color: '#333', 
                    marginBottom: '15px',
                    fontSize: '24px'
                }}>
                    Cancel Order?
                </h2>
                
                <p style={{ 
                    color: '#666', 
                    marginBottom: '30px',
                    fontSize: '16px',
                    lineHeight: '1.5'
                }}>
                    Are you sure you want to cancel your current order? 
                    All selected products will be removed from your cart.
                </p>

                <div style={{
                    display: 'flex',
                    gap: '15px',
                    justifyContent: 'center'
                }}>
                    <button
                        onClick={onCancel}
                        style={{
                            padding: '12px 24px',
                            border: '2px solid #e0e0e0',
                            background: 'white',
                            color: '#666',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            fontWeight: '600'
                        }}
                    >
                        📝 Keep Editing
                    </button>
                    
                    <button
                        onClick={onConfirm}
                        style={{
                            padding: '12px 24px',
                            border: 'none',
                            background: 'linear-gradient(135deg, #f44336 0%, #d32f2f 100%)',
                            color: 'white',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            fontWeight: '600'
                        }}
                    >
                        ❌ Yes, Cancel Order
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CancelOrderModal;
